import { Select } from '../common/interfaces';
import {
  Country,
  ICurrencyResponse,
  VirtualAsset,
} from '../store/api/types.api';

export const getCountriesSelect = (countries: Country[]): Select[] => {
  // Select для выбора типа документа при создании нового документа
  return countries.map((el) => ({
    value: el.id,
    label: el.name,
  }));
};

export const getCurrencySelect = (currency: ICurrencyResponse[]): Select[] => {
  return currency.map((el) => ({
    value: el.id,
    label: el.name,
  }));
};

export const getVirtualActiveSelect = (
  virtualActive: VirtualAsset[],
): Select[] => {
  return virtualActive.map((el) => ({
    value: el.id,
    label: el.name,
  }));
};
